export const codeTypes = {
  hs: 'hs',
  hts: 'hts',
}
